<template>
    <div
        class="widget-agent-box widget-agent-box-container mt-6 mb-6 pa-6"
        :class="normalizedOptions.container.classes"
        :style="normalizedOptions.container.style"
        v-if="normalizedOptions.container.show"
    >
        <v-row class="align-center">
            <v-col cols="12" md="6" order="1" order-md="2">
                <div
                    class="logo-container d-flex justify-content-center align-items-center"
                    v-if="agent.logoUrl && normalizedOptions.logo.show"
                    :class="normalizedOptions.logo.container.classes"
                    :style="normalizedOptions.logo.container.style"
                >
                    <v-img
                        max-width="200"
                        contain
                        :src="agent.logoUrl"
                        :alt="agent.name"
                        :class="normalizedOptions.logo.classes"
                        :style="normalizedOptions.logo.style"
                    />
                </div>
            </v-col>
            <v-col cols="12" md="6" order="2" order-md="1">
                <div class="text-container">
                    <div
                        v-if="normalizedOptions.title.show"
                        :class="normalizedOptions.title.container.classes"
                        :style="normalizedOptions.title.container.style"
                    >
                        <h2
                            :class="normalizedOptions.title.classes"
                            :style="normalizedOptions.title.style"
                        >
                            {{ normalizedOptions.title.text }}
                        </h2>
                    </div>
                    <div
                        v-if="normalizedOptions.intro.show"
                        :class="normalizedOptions.intro.container.classes"
                        :style="normalizedOptions.intro.container.style"
                    >
                        <div
                            v-html="normalizedOptions.intro.textHtml"
                            :class="normalizedOptions.intro.classes"
                            :style="normalizedOptions.intro.style"
                        >
                        </div>
                    </div>
                    <div
                        v-if="normalizedOptions.button.show"
                        :class="normalizedOptions.button.container.classes"
                        :style="normalizedOptions.button.container.style"
                    >
                        <v-btn color="primary"
                                outlined
                                block
                                large
                                :href="normalizedOptions.button.href">
                            {{ normalizedOptions.button.text }}
                        </v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {defineComponent, ref, onMounted, computed} from "@vue/composition-api";
import {merge} from "lodash";

export default defineComponent({
    name: "ListingAgentBox",
    components: {},
    props: {
        agent: {
            type: Object,
            default: () => ({})
        },
        settings: {
            type: Object
        },
    },
    setup(props) {
        const loading = ref(false);
        const defaultSettings = ref({
            container: {
                style: 'background-color: #E8E8E8',
                classes: '',
                show: true
            },
            title: {
                show: true,
                text: 'Interested in this development?',
                style: '',
                classes: 'mb-6',
                container: {
                    style: '',
                    classes: ''
                }
            },
            intro: {
                show: true,
                textHtml: 'We are working with ' + props.agent.name + ' who are selling these homes on our behalf',
                style: '',
                classes: 'mb-6',
                container: {
                    style: '',
                    classes: ''
                }
            },
            button: {
                show: true,
                text: 'Register Now',
                href: '#register',
                style: '',
                classes: '',
                container: {
                    style: '',
                    classes: ''
                }
            },
            logo: {
                show: true,
                style: '',
                classes: '',
                container: {
                    style: '',
                    classes: ''
                }
            }
        });

        const normalizedOptions = computed(() => {
            return merge(defaultSettings.value, props.settings);
        });

        onMounted(() => {
            init();
        });

        function init() {

        }

        return {
            // Variables
            loading,
            normalizedOptions
            // Functions
        };
    }
});
</script>
<style>
</style>
